import { Component, EventEmitter, Input, Output, inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { DrawerBottomBarButton } from '@sbd-account-portal/app/modules/main-fuse-drawer/menus-buttons-template.types';

@Component({
  selector: 'sbd-doug-frontend-common-drawer-footer',
  standalone: true,
  imports: [
    CommonModule,
    MatButton,
    MatIcon,
    NgClass,
  ],
  templateUrl: './common-drawer-footer.component.html',
})
export class CommonDrawerFooterComponent implements OnInit, OnDestroy {
  @Input() buttons: DrawerBottomBarButton[] = [];
  @Input() buttonPosition: 'start' | 'end' | 'between' | 'center' = 'between';
  @Input() componentRef: any = null; // Reference to the parent component for string actions

  @Output() buttonClick = new EventEmitter<DrawerBottomBarButton>();

  private _unsubscribeAll = new Subject<void>();

  get visibleButtons(): DrawerBottomBarButton[] {
    return this.buttons.filter(button => button.visible !== false);
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  onButtonClick(button: DrawerBottomBarButton): void {
    if (!button.enabled) {
      return;
    }

    this.buttonClick.emit(button);

    if (typeof button.action === 'function') {
      button.action();
    } else if (typeof button.action === 'string' && this.componentRef) {
      this.handleStringAction(button.action);
    }
  }

  private handleStringAction(action: string): void {
    if (this.componentRef && typeof this.componentRef[action] === 'function') {
      this.componentRef[action]();
    } else {
      console.warn(`Action method '${action}' not found on component reference`);
    }
  }

  getButtonClasses(button: DrawerBottomBarButton): string {
    const baseClasses = 'ml-2';
    const colorClasses = button.color === 'primary' ? 'mat-flat-button-primary' : '';
    return `${baseClasses} ${colorClasses}`.trim();
  }
}
